import { z } from 'zod';
import {
  SignalVisibilityType,
  SignalApplicabilityScope,
  SEVERITY_LABELS,
} from '@momentum/types';

const usersAndTeamsSchema = z.object({
  users: z.array(z.string()),
  teams: z.array(z.string()),
});

export const createSignalSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  severity: z.number(),
  relevantParties: usersAndTeamsSchema,
  visibility: z.nativeEnum(SignalVisibilityType),
  viewableBy: usersAndTeamsSchema,
  isAnonymous: z.boolean(),
  applicabilityScope: z.nativeEnum(SignalApplicabilityScope),
});

export type CreateSignalFormData = z.infer<typeof createSignalSchema>;

export const defaultCreateSignalValues: CreateSignalFormData = {
  title: '',
  severity: SEVERITY_LABELS.Medium,
  relevantParties: { users: [], teams: [] },
  visibility: SignalVisibilityType.PUBLIC,
  viewableBy: { users: [], teams: [] },
  isAnonymous: false,
  applicabilityScope: SignalApplicabilityScope.SELF,
};
